/**
 * Mandatory reason field for every ops mutation.
 * Renders a textarea; calls onChange with the current value.
 */
export default function ReasonField({ value, onChange, placeholder = 'Reason for this change (e.g. ticket #123)' }) {
  return (
    <div className="reason-field">
      <label className="form-label">
        Reason <span className="required">*</span>
      </label>
      <textarea
        className="form-input reason-textarea"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        rows={2}
        required
      />
    </div>
  );
}
